var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.52,
    height: 19.89,
    viewBox: "0 0 26.52 19.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icons",
    d: "M0,2.338v-.68A1.657,1.657,0,0,1,1.657,0h23.2a1.657,1.657,0,0,1,1.657,1.657v.68L13.26,10.625Zm13.7,9.968a.83.83,0,0,1-.878,0L0,4.292v13.94A1.657,1.657,0,0,0,1.657,19.89h23.2a1.657,1.657,0,0,0,1.657-1.657V4.292Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ff52be0a900d880c76bec7c98716cd4b.svg";
export { ForwardRef as ReactComponent };